import { service } from '@/ajax/request'
import { Id } from '@/types/common'
import { CreateDiscountTag, EnterAudit } from '@/types/api/discount'



// 新建折扣标签
export const createDiscountTag = (params: CreateDiscountTag) => (
  service({
    url: '/sys/discount/createLabel',
    method: 'POST',
    params
  })
)

// 根据ID删除初始化标签
export const deleteDiscountTag = (params: Id) => (
  service({
    url: `/sys/discount/deleteLabel/${params.id}`,
    method: 'POST',
    params,
    type: 'form'
  })
)

// 查询所有初始化折扣标签
export const selectAllLabel = (params: Id = { id: 0 }) => (
  service({
    url: `/sys/discount/selectAllLabel`,
    method: 'GET',
    type: 'form'
  })
)

// 查询会员入驻信息设置（入驻费用） 1= 个人或者学员 2 企业或者门店
export const selectDiscountById = (params: Id) => (
  service({
    url: `/sys/discount/selectDiscount/${params.id}`,
    method: 'GET',
    params,
    type: 'form'
  })
)

// 修改会员入驻信息设置（入驻费用）
export const updateDiscountById = (params: Id) => (
  service({
    url: `/sys/discount/updateEnter/${params.id}`,
    method: 'POST',
    params
  })
)

// 修改会员入驻信息设置（入驻费用）
export const getEnterAudit = () => (
  service({
    url: `/member/updateEnterAudit`,
    method: 'GET'
  })
)


// 修改会员入驻信息设置（入驻费用）
export const updateEnterAudit = (params: EnterAudit) => (
  service({
    url: `/member/updateEnterAudit`,
    method: 'POST',
    params,
    type: 'form'
  })
)